import * as React from 'react';
import { CellTypeDef } from 'common/components/table-react/types';
import styles from './index.module.styl';
export const TextCellType: CellTypeDef<unknown, string> = {
  template: (value: string, context) => {
    const filterMatch = context.getFilterMatch();
    if (filterMatch) {
      return <div className={styles.textCellRoot}>
          <span className={styles.text}>
            {filterMatch.matchParts.map((part, idx) => <span key={idx} className={styles.matchPart}>
                {part}
              </span>)}
          </span>
        </div>;
    }
    return <div className={styles.textCellRoot}>
        <span className={styles.text}>{value}</span>
      </div>;
  }
};
export const RawNumberCellType: CellTypeDef<unknown, number> = {
  template: (value: number, context) => {
    const filterMatch = context.getFilterMatch();
    if (filterMatch) {
      return <div className={styles.numberCellRoot}>
          <span className={styles.text}>
            {filterMatch.matchParts.map((part, idx) => <span key={idx} className={styles.matchPart}>
                {part}
              </span>)}
          </span>
        </div>;
    }
    return <div className={styles.numberCellRoot}>
        <span className={styles.text}>{value}</span>
      </div>;
  },
  textTransform: (value: number) => String(value)
};